module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "title my-2"
  }, [_vm._v("Processo Seletivo")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.form.ref_processo_seletivo))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "title my-2"
  }, [_vm._v("Local Prova")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.form.local_prova))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "title my-2"
  }, [_vm._v("Opcões de Cursos")])]), _vm._v(" "), _vm._l((_vm.cursos), function(curso) {
    return _c('v-flex', {
      staticClass: "mb-2",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_c('strong', [_vm._v(_vm._s(curso.opcao) + "ª Opção")])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_c('strong', [_vm._v("Curso:")])]), _vm._v(" "), _c('span', {
      staticClass: "dado"
    }, [_vm._v(_vm._s(curso.curso))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_c('strong', [_vm._v("Campus:")])]), _vm._v(" "), _c('span', {
      staticClass: "dado"
    }, [_vm._v(_vm._s(curso.campus))])])], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "title my-2"
  }, [_vm._v("Dados Pessoais")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome Completo:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.nome))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("E-mail:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.email))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefono:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.telefone))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.cpf))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("RG:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.rg))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Data Nascimento:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("dateEnToBr")(_vm.form.dt_nascimento)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Sexo:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.sexo == 'M' ? 'Masculino' : 'Feminino'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("ENEM:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.enem))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Ano ENEM:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.ano_enem))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Treineiro:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.treineiro ? 'Sim' : 'Não'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Possui Necessita Especiais?")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.fl_necessidade_especial ? 'Sim' : 'Não'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Necessita de auxílio para realizar a prova?")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.auxilio_prova ? 'Sim' : 'Não'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Podemos usar o Whatsapp, E-Mail e SMS para falar sobre sua inscrição e matricula?")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.fl_receber_contato ? 'Sim' : 'Não'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "title my-2"
  }, [_vm._v("Endereço")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CEP:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.cep))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Endereço:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.endereco))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Número:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.numero))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Complemento:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.complemento))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Cidade:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.cidade))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Bairro:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.bairro))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Estado:")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.form.estado))])])], 1)], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8f603b58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/vestibular/components/etapas/Confirmacao.vue
// module id = 568
// module chunks = 2